<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-1 mr-2"
          color="primary"
          v-on="on"
          v-bind="attrs"
          :disabled="params && params.data.total_records === 0"
          @click="viewItem"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          :disabled="params && params.data.total_records === 0"
          v-bind="attrs"
          @click="showApprove"
        >
          mdi-bookmark-check
        </v-icon>
      </template>
      <span>SAP Approved</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-1 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewLogs"
        >
          mdi-history
        </v-icon>
      </template>
      <span>Logs</span>
    </v-tooltip>

    <v-tooltip top v-if="canDelete">
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-1 mr-1"
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="deleteItem"
        >
          mdi-delete
        </v-icon>
      </template>
      <span>Delete</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    canDelete() {
      const permissions =
        this.params &&
        this.params.context &&
        this.params.context.parentComponent &&
        this.params.context.parentComponent.superuserPermissions;
      return !!(permissions && permissions.change);
    },
  },
  methods: {
    viewItem() {
      this.params.context.parentComponent.viewPayout(this.params.data.id);
    },
    showApprove() {
      this.params.context.parentComponent.showApproveData(this.params.data.id);
    },
    viewLogs() {
      this.params.context.parentComponent.viewBonusLogs(this.params.data.id);
    },
    deleteItem() {
      this.params.context.parentComponent.deleteBonusPayout(this.params.data);
    },
  },
};
</script>
